// 资金预测卡片样式
const fundingForecastCardStyle = {
  padding: '30px 30px 10px 24px'
}
const fundStatisticsCardStyle = {
  padding: '30px 24px'
}
export const fundingForecastOption = [
  {
    cardStyle: fundingForecastCardStyle,
    icon: 'icon1',
    title: '明日预计回款',
    tip: '(租后催收及代偿管理还租日期为明日的本期应还租金总和)*有效回款率',
    valueKey: 'expCollectionTomorrow',
    img: 'image1',
    unit: '元',
  },
  {
    cardStyle: fundingForecastCardStyle,
    icon: 'icon2',
    title: '明日预计放款',
    tip: '近30天【不含当天】已处理放款平均值(放款为0的日期不计入计算)',
    valueKey: 'expDisbursementTomorrow',
    img: 'image2',
    unit: '元',
  },
  {
    cardStyle: fundingForecastCardStyle,
    icon: 'icon8',
    title: '建议备付金额',
    tip: '明日预计放款-明日预计回款',
    valueKey: 'reserveAmount',
    img: 'image3',
    unit: '元',
  },
  {
    cardStyle: fundingForecastCardStyle,
    icon: 'icon9',
    title: '安全资金阈值',
    tip: '近30天已处理放款(今日已处理放款)平均值*/',
    valueKey: 'fundThreshold',
    img: 'image4',
    unit: '元',
  },
]

export const fundStatisticsOption = [
  {
    cardStyle: fundStatisticsCardStyle,
    icon: 'icon1',
    title: '昨日财务放款',
    tip: '昨日(财务放款+代理商返佣+平台还款)总和',
    valueKey: 'yestFinDisbursement',
    img: '',
    unit: '元',
  },
  {
    cardStyle: fundStatisticsCardStyle,
    icon: 'icon2',
    title: '本月日均财务放款',
    tip: '本月(财务放款+代理商返佣+平台还款)平均值',
    valueKey: 'mthAvgDlyFinDisbursement',
    img: '',
    unit: '元',
  },
  {
    cardStyle: fundStatisticsCardStyle,
    icon: 'icon3',
    title: '上月回款率',
    tip: '上月实收客户数总数/上月应收客户总数，单位%，两位小数，四舍五入',
    valueKey: 'lastMthCollectionRate',
    img: '',
    unit: '%',
  },
  {
    cardStyle: fundStatisticsCardStyle,
    icon: 'icon4',
    title: '本年回款率',
    tip: '本年实收客户数总数/本年应收客户总数，单位%，两位小数，四舍五入',
    valueKey: 'thisYrCollectionRate',
    img: '',
    unit: '%',
  },
  {
    cardStyle: fundStatisticsCardStyle,
    icon: 'icon5',
    title: '今日现金流',
    tip: '今日已处理回款-今日已处理放款',
    valueKey: 'cashFlowToday',
    img: '',
    unit: '元',
  },
  {
    cardStyle: fundStatisticsCardStyle,
    icon: 'icon6',
    title: '今日已处理回款',
    tip: '今日已处理(招商收款+投诉收款+租后收款+谈判收款+结清收款+法务收款+卖车收款)总和',
    valueKey: 'procCollectionToday',
    img: '',
    unit: '元',
  },
  {
    cardStyle: fundStatisticsCardStyle,
    icon: 'icon7',
    title: '今日已处理放款',
    tip: '今日已处理(财务放款+代理商返佣+平台还款)总和',
    valueKey: 'procDisbursementToday',
    img: '',
    unit: '元',
  },
]

export const echartOption = {
  legend: {
    data: ['现金流'],
    top: '5%',
  },
  grid: {
    left: '1.5%',
    right: '0%',
    bottom: '0%',
    containLabel: true,
  },
  tooltip: {
    trigger: 'axis',
    valueFormatter: value => (value + '元')
  },
  xAxis: {
    type: 'category',
    data: [],
    axisTick: {
      alignWithLabel: true
    }
  },
  yAxis: {
    type: 'value',
    name: '单位: 元'
  },

  series: {
    name: '现金流',
    type: 'bar',
    data: [],
    barWidth: '20%',
    itemStyle: {
      color: '#18B0FF',
    },
  },
}